import { ArrowRight } from "lucide-react";
import posthog from "@/lib/posthog";

export default function FinalCtaSection() {
  return (
    <section id="contact" className="relative overflow-hidden bg-[#070D1A] py-24 sm:py-32">
      {/* Dot grid texture */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.045) 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />

      {/* Central glow */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 h-[500px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#0092B4]/[0.12] blur-[120px]" />
      </div>

      <div className="relative mx-auto w-full max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-[clamp(2.1rem,5.5vw,3.75rem)] font-bold leading-[1.07] tracking-[-0.035em] text-white mb-6">
          Intelligence on every call.{" "}
          <span className="text-[#0092B4]">Zero admin after it.</span>
        </h2>
        <p className="mx-auto max-w-xl text-[1.05rem] leading-relaxed text-slate-400 mb-3">
          Shadow gives your team live intelligence on every call.
        </p>
        <p className="mx-auto max-w-xl text-[1.05rem] leading-relaxed text-slate-400 mb-10">
          Everything after — CRM updates, follow-up emails, Jira tickets — handled automatically.
        </p>

        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <a
            href="mailto:hello@shadowlabs.ai?subject=Shadow Demo Request"
            onClick={() => posthog.capture("landing.book_demo.clicked", { location: "final_cta" })}
            className="inline-flex h-12 items-center justify-center gap-2 rounded-full bg-[#0092B4] px-8 text-[15px] font-medium text-white
              shadow-[0_0_20px_2px_rgba(0,146,180,0.2)]
              transition-all duration-300
              hover:bg-[#007a98] hover:shadow-[0_0_28px_6px_rgba(0,146,180,0.35)]
              active:scale-[0.98]"
          >
            Book a Demo
            <ArrowRight className="h-4 w-4" strokeWidth={2.5} />
          </a>
          <a
            href="https://github.com/Converse-AI-Inc/Shadow/releases/latest/download/Shadow.dmg"
            onClick={() => posthog.capture("landing.download_app.clicked", { location: "final_cta" })}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-12 items-center justify-center gap-2 rounded-full border border-white/20 px-8 text-[15px] font-medium text-slate-300 transition-all hover:border-white/35 hover:text-white"
          >
            Download App
          </a>
        </div>

        <p className="mt-8 text-[12px] text-slate-600">
          Works on macOS · Google Meet, Zoom, and Teams · No credit card required to start
        </p>
      </div>
    </section>
  );
}
